import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import TermsAndFormsPageData from 'Models/Content/TermsAndFormsPageData';

export default class TermsAndFormsPage extends Page<TermsAndFormsPageData> {
  render() {
    const {
      data: {mainContentArea, title, subtitle},
      context,
    } = this.props;
    return (
      <div className='TermsAndFormsPage'>
        <div className='TermsAndFormsPage__head'>
          <h1>{title.value}</h1>
          <h3>{subtitle.value}</h3>
        </div>
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
